export function arrangeObjectKeysInAlphabeticalOrder<T extends Record<string, unknown>>(object: T): T {
  const keys: (keyof T)[] = Object.keys(object).sort();

  const newObject = keys.reduce((acc: Partial<T>, key): Partial<T> => {
    acc[key] = object[key];

    return acc;
  }, {});

  return newObject as T;
}
